import { render, staticRenderFns } from "./EmojiPicker.vue?vue&type=template&id=4c361f85&scoped=true&"
import script from "./EmojiPicker.vue?vue&type=script&lang=ts&"
export * from "./EmojiPicker.vue?vue&type=script&lang=ts&"
import style0 from "./EmojiPicker.vue?vue&type=style&index=0&id=4c361f85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c361f85",
  null
  
)

export default component.exports